import React, { useState } from "react";
import { PropertyInfo, PropertyFeatures } from "../../../utils/constants";
import styles from "./AddDocumentForm.module.scss";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../../Firebase/Firebase";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface AddDocumentFormProps {
  structure: PropertyInfo;
  onAdd: (formData: any) => void;
  ubications: string[];
  propertyTypes: string[];
  businessTypes: string[];
}

export function AddDocumentForm({
  structure,
  onAdd,
  ubications,
  propertyTypes,
  businessTypes,
}: AddDocumentFormProps) {
  const [formData, setFormData] = useState<PropertyInfo>(structure);
  const [caracteristicas, setCaracteristicas] = useState<PropertyFeatures>({});
  const [open, setOpen] = useState(false);
  const [numOfImage, setNumOfImage] = useState(1);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCaracteristicasChange = (key: string, value: string) => {
    setCaracteristicas({ ...caracteristicas, [key]: value });
    setFormData({
      ...formData,
      ["caracteristicas"]: { ...caracteristicas, [key]: value },
    });
  };

  const addCaracteristica = () => {
    setCaracteristicas({
      ...caracteristicas,
      [`caracteristica_${Object.keys(caracteristicas).length + 1}`]: "",
    });
  };

  const handleChange = (
    name: string,
    value: string | number | boolean | File[]
  ) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const imagesLinks: string[] = [];

    try {
      if (formData.imagenes && formData.imagenes.length > 0) {
        handleOpen();
        let i = 1;
        for (const image of formData.imagenes) {
          const uniqueName = `${new Date().getTime()}-${image.name}`;
          const imagesRef = ref(storage, `imagenes/${uniqueName}`);

          const snapshot = await uploadBytes(imagesRef, image);
          setNumOfImage(i++);

          const downloadURL = await getDownloadURL(snapshot.ref);
          imagesLinks.push(downloadURL);
        }
        handleClose();

        setFormData({ ...formData, imagenesURLs: imagesLinks, imagenes: [] });
      }
    } catch (error) {
      console.log(error);
    }

    onAdd({ ...formData, imagenesURLs: imagesLinks, imagenes: [] });
  };

  return (
    <form onSubmit={handleSubmit} className={styles.formContainer}>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Por favor espera
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Guardando imagen {numOfImage} de {formData.imagenes?.length}
          </Typography>
        </Box>
      </Modal>
      {Object.entries(structure).map(([key, value]) => {
        if (key === "caracteristicas") {
          return (
            <div key={key} className={styles.fieldContainer}>
              <label className={styles.label}>{key}</label>
              {Object.entries(caracteristicas).map(
                ([caracteristicaKey, caracteristicaValue], index) => (
                  <div key={caracteristicaKey}>
                    <input
                      type="text"
                      value={caracteristicaValue}
                      onChange={(e) =>
                        handleCaracteristicasChange(
                          caracteristicaKey,
                          e.target.value
                        )
                      }
                      className={styles.input}
                    />
                  </div>
                )
              )}
              <button type="button" onClick={addCaracteristica}>
                Agregar Característica
              </button>
            </div>
          );
        }
        if (key === "ciudad") {
          return (
            <div key={key} className={styles.fieldContainer}>
              <label className={styles.label}>{key}</label>
              <select
                value={formData[key as keyof PropertyInfo] as string}
                onChange={(e) => handleChange(key, e.target.value)}
                className={styles.input}
              >
                {ubications.map((ubication) => (
                  <option key={ubication} value={ubication}>
                    {ubication}
                  </option>
                ))}
              </select>
            </div>
          );
        }
        if (key === "tipoDePropiedad") {
          return (
            <div key={key} className={styles.fieldContainer}>
              <label className={styles.label}>{key}</label>
              <select
                value={formData[key as keyof PropertyInfo] as string}
                onChange={(e) => handleChange(key, e.target.value)}
                className={styles.input}
              >
                {propertyTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          );
        }
        if (key === "tipoDeNegocio") {
          return (
            <div key={key} className={styles.fieldContainer}>
              <label className={styles.label}>{key}</label>
              <select
                value={formData[key as keyof PropertyInfo] as string}
                onChange={(e) => handleChange(key, e.target.value)}
                className={styles.input}
              >
                {businessTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          );
        }
        if (key === "descripcion") {
          return (
            <div key={key}>
              <label className={styles.label}>{key}</label>
              <textarea
                value={(formData[key as keyof PropertyInfo] as string) || ""}
                onChange={(e) => handleChange(key, e.target.value)}
                style={{ width: "100%", height: "100px" }}
                rows={5}
                cols={50}
              />
            </div>
          );
        }
        if (key in formData) {
          const inputValue = formData[key as keyof PropertyInfo];
          return (
            <div key={key} className={styles.fieldContainer}>
              <label>{key}</label>
              <br />
              {typeof value === "string" && (
                <input
                  type="text"
                  value={(inputValue as string) || ""}
                  onChange={(e) => handleChange(key, e.target.value)}
                  style={{ width: "100%", height: "30px" }}
                />
              )}
              {typeof value === "number" && (
                <input
                  type="number"
                  value={(inputValue as number) || 0}
                  onChange={(e) => handleChange(key, Number(e.target.value))}
                />
              )}
              {typeof value === "boolean" && (
                <input
                  type="checkbox"
                  checked={!!inputValue}
                  onChange={(e) => handleChange(key, e.target.checked)}
                />
              )}
              {key === "imagenes" && (
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => {
                    const files = e.target.files;
                    if (files) {
                      handleChange(key, Array.from(files) as unknown as File[]);
                    }
                  }}
                />
              )}
            </div>
          );
        }
        return null;
      })}

      <div className={styles.buttonContainer}>
        <button type="submit" className={styles.submitButton}>
          Guardar casa
        </button>
      </div>
    </form>
  );
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
